import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { icons } from './mdi-icon'; // Import icons from separate file
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { PurpleTheme } from '@/theme/LightTheme';
import { DarkPurpleTheme } from '@/theme/DarkTheme';

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      ...icons
    },
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: 'PurpleTheme',
    themes: {
      PurpleTheme,
      DarkPurpleTheme
    }
  },
  defaults: {
    VBtn: {
      rounded: 'md',
      variant: 'flat',
      // No global size — explicit per usage. Icon-only buttons get square
      // via the 'icon' prop, never implicit height/width.
    },
    VBtnGroup: {
      rounded: 'md',
      variant: 'outlined'
    },
    VCard: {
      rounded: 'lg'
    },
    VTextField: {
      rounded: 'md',
      variant: 'outlined',
      color: 'primary',
      density: 'comfortable'
    },
    VSelect: {
      rounded: 'md',
      variant: 'outlined',
      color: 'primary',
      density: 'comfortable'
    },
    VTextarea: {
      rounded: 'md',
      variant: 'outlined',
      color: 'primary'
    },
    VTooltip: {
      location: 'top'
    },
    VAlert: {
      rounded: 'md',
      variant: 'tonal'
    },
    VChip: {
      rounded: 'sm'
    }
  }
});
